<script lang="ts">
    import {Color, SVGMap} from "./map";
    import {createEventDispatcher, onDestroy} from "svelte";
    import type {Region} from "./model";

    export let path: string;
    export let regions: Region[];
    export let fills: {
	    [key: string]: Color
    } = {};
    export let markings: {
	    [key: string]: 'striped' | 'dotted'
    } = {};
	export let lastClicked: string = null;
	export let svgStyles = '';
	export let loaded = false;

    let object: HTMLObjectElement;
    let map: SVGMap;
    const dispatch = createEventDispatcher<{
	    communityClick: string,
	    communityHover: {
		    key: string,
		    e: MouseEvent
	    },
	    communityUnhover: string,
	    loaded: null,
	    error: any,
    }>();
    let _loaded = false;

    // set default fills when regions change
    $: {
	    setFillsFromRegions(regions || []);
	    if (map) map.fillCommunities(fills);
    }
    // fill / mark specified communities
    $: if (map) map.fillCommunities(fills);
    $: if (map) map.markCommunities(markings);
	$: if (map) map.setLastClicked(lastClicked);

    onDestroy(() => {
	    if (map) {
		    map.destroy();
	    }
    });

    function svgLoaded() {
	    _loaded = true;
	    initMap();
    }

    function initMap() {
	    if (!_loaded) {
		    return;
	    }
	    if (map) {
		    map.destroy();
	    }
	    map = new SVGMap(
		    id => {
				lastClicked = id;
				dispatch('communityClick', id);
		    },
		    (id, e) => dispatch('communityHover', {key: id, e}),
		    id => dispatch('communityUnhover', id),
		    "#FFFFFF",
		    object
	    );
		loaded = true;
	    dispatch('loaded');
    }

    function setFillsFromRegions(regions: any[]) {
	    if (!map)
		    return;

	    const colorMap: { [key: string]: Color } = {};
	    for (let r of regions) {
		    const communities = r.communities;
		    for (let c of communities) {
			    colorMap[c.key] = r.color;
			    // colorMap[c.key] = 'red'; // for testing
		    }
	    }
	    map.setFills(colorMap);
    }
</script>

<object title="Map" bind:this={object} on:error={e => dispatch('error', e)} on:load={svgLoaded} data={path}
        style="width: 100%; {svgStyles}" type="image/svg+xml"></object>
